import React from "react";
import styles from "./dashboardPageChrome.module.scss";

const DashboardPageChrome = ({ children }) => (
  <div className={styles.root}>{children}</div>
);

export default DashboardPageChrome;
